import { Controller } from "@hotwired/stimulus"

// 診察メモの開閉を制御
export default class extends Controller {
  static targets = ["content", "icon", "label"]

  toggle() {
    const isHidden = this.contentTarget.classList.contains("hidden")
    this.contentTarget.classList.toggle("hidden")
    this.iconTarget.classList.toggle("rotate-180")
    this.labelTarget.textContent = isHidden ? "閉じる" : "開く"
  }
}
